<template>
    <form @submit.prevent="handleSubmit(item)" novalidate>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
            <label for="_name" class="control-label">Imię</label>
            <input v-model="item.name" type="text" id="_name" class="form-control" />
            <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.surname) }">
            <label for="_surname" class="control-label">Nazwisko</label>
            <input v-model="item.surname" type="text" id="_surname" class="form-control" />
            <span v-if="errors && errors.surname" class="help-block" id="_surname_helpBlock">{{ errors.surname }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.email) }">
            <label for="_email" class="control-label">E-mail</label>
            <input v-model="item.email" type="email" id="_email" class="form-control" />
            <span v-if="errors && errors.email" class="help-block" id="_email_helpBlock">{{ errors.email }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.roles) }">
            <label for="_roles" class="control-label">Role</label>
            <div class="select__container form-group">
                <b-form-select multiple v-model="item.roles" :options="userRoles" class="mb-3" id="_roles"></b-form-select>
            </div>
            <span v-if="errors && errors.roles" class="help-block" id="_roles_helpBlock">{{ errors.roles }}</span>
        </div>

        <router-link :to="{ name: 'UserList' }" class="btn btn-primary"><span>Powrót</span><svg-icon name="back"/></router-link>
        <my-button text="Zapisz" icon="tick" type="submit" />
    </form>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      },

    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : this.values;
      },
      ...mapGetters({
        userRoles: 'config/config/userRoles'
      }),
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?85e09588